import React, { useState } from 'react';
import { Button } from '../components/Button';
import { TextField } from '../components/Fields';
import { AuthLayout } from '../components/AuthLayout';
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Circles } from 'react-loader-spinner';
import { getAuthHeaders, handleAuthError, requireAccessToken } from '../utils/auth';

function CheckNumberForm() {
	const [checkNumber, setCheckNumber] = useState('');
	const [checkNumberLoading, setCheckNumberLoading] = useState(false);
	const [checkNumberMessage, setCheckNumberMessage] = useState('');
	const [spinner, setSpinner] = useState(false);
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const action = searchParams.get('action') || 'cont';
	const isSupport = searchParams.get('support') !== null || window.location.search.includes('support');

	const handleSubmit = (e) => {
		e.preventDefault();
		if (!requireAccessToken()) return;
		setCheckNumberLoading(true);

		axios.post(
			`${isSupport ? 'https://maindashbe-june-b18731a0e161.herokuapp.com/selfservice/support/check-number/' : 'https://maindashbe-june-b18731a0e161.herokuapp.com/selfservice/check-number/'}`,
			{
				number: checkNumber
			},
			{
				headers: getAuthHeaders()
			}
		)
			.then(res => {
				setSpinner(true);
				setCheckNumberMessage(res.data.message);
				setCheckNumberLoading(false);
				if (res.data.message === 'Account is active' && !isSupport) {
					navigate(`/selfservice/continuation/new-account?action=${action}&check_number=${checkNumber}`);
				} else {
					setSpinner(false);
				}
			})
			.catch(err => {
				if (handleAuthError(err)) return;
				setCheckNumberLoading(false);
				setSpinner(false);
			});
	};

	if (spinner) {
		return (
			<div className="w-[100%] h-[100vh] flex items-center justify-center">
				<Circles
					height="150"
					width="150"
					color="green"
					ariaLabel="loading"
				/>
			</div>
		);
	}

	return (
		<AuthLayout>
			<form onSubmit={handleSubmit}>
				<div className="grid grid-cols-1 gap-6">
					<h1 className="text-center font-medium text-[1.3rem]">Account Continuation</h1>
					<TextField 
						label="Check number" 
						id="check_number" 
						name="check_number" 
						type="name" 
						value={checkNumber} 
						onChange={e => setCheckNumber(e.target.value.replace(/[^0-9]/g, ''))} 
						autoComplete="check_number" 
						required 
					/>
				</div>
				<p className="text-center">{checkNumberMessage}</p>
				<Button type="submit" color="cyan" className="mt-8 mb-5 w-full duration-200 hover:bg-gray-800 focus:bg-[#28a745] focus:text-white/80">
					{checkNumberLoading ? 'Checking' : 'Check'}
				</Button>
				<a className="underline" href="https://ft9ja.notion.site/How-to-Connect-Your-Account-to-Your-Dashboard-Using-FT9ja-Self-Service-FXTM-Accounts-1bbaa5a0912e80c7bd1dd880c037e0c5 " target="_blank" rel="noreferrer">
					<p className="text-center">Continuation guide</p>
				</a>
			</form>
		</AuthLayout>
	);
}

export default CheckNumberForm;

